import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  "image-rendering": "optimizeQuality",
  "shape-rendering": "geometricPrecision",
  "text-rendering": "geometricPrecision",
  viewBox: "0 0 1024 1024",
  width: "48px",
  height: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "ec-69b97df8-9619-4290-b489-7196ed964fa1-__图层_x0020_1" }, [
      _createElementVNode("path", {
        d: "M 512 0 C 794.721 0 1024 229.28 1024 512 C 1024 794.721 794.721 1024 512 1024 C 229.28 1024 0 794.721 0 512 C 0 229.28 229.28 0 512 0 Z M 457.148 556.058 L 457.148 292.539 C 457.148 262.328 481.791 237.686 512 237.686 C 542.211 237.686 566.853 262.557 566.853 292.539 L 566.853 556.058 C 566.853 586.04 542.21 610.911 512 610.911 C 481.79 610.911 457.148 586.268 457.148 556.058 Z M 511.763 669.742 C 546.094 669.742 573.937 697.585 573.937 731.911 C 573.937 766.242 546.094 794.085 511.763 794.085 C 477.437 794.085 449.594 766.242 449.594 731.911 C 449.594 697.585 477.437 669.742 511.763 669.742 Z",
        fill: "#f00"
      })
    ], -1)
  ]))]))
}
export default { render: render }